/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Button, ProgressSteps, AuthContext, Loader } from 'components/lib';
import Style from './finish-campaign.module.scss';
import axios from 'axios';
import Astronauta from '../../../../assets/astronauta_5.svg';
import Fail from '../../../../assets/astronauta_fail.svg';
import { readCampaignResponse } from './campaign-response';


export function CampaignFinish(props){

  // context
  const authContext = useContext(AuthContext);

  const [campaignState, setCampaignState] = useState(null);
  const [campaignError, setCampaignError] = useState(null);
  const [campaignResult, setCampaignResult] = useState(null);
  const [statusWarning, setStatusWarning] = useState('');

  useEffect(() => {

    if(authContext.state && 
      authContext.state.data_campaign && 
      authContext.state.data_campaign.name) {
      let createCampaignObj = {
        campaign_name: authContext.state.data_campaign.name,
        templates: authContext.state.data_campaign.selectThemesScreen ? authContext.state.data_campaign.selectThemesScreen.map(val => val.obj) : [],
        leads_ids: authContext.state.data_campaign.leadListId,
        msg_info: authContext.state.data_campaign.summary
      }

      sendCampaign(createCampaignObj);

      authContext.dispatch({ type: 'DELETE_CAMPAIGN', value: { } })
    } else {
      window.location.href = window.location.origin + '/campaign';
    }

  }, [])

  async function sendCampaign(obj){
    let aux = obj;

    try {
      const res = await axios({ 
        url: '/api/user/campaign',
        method: 'post',
        data: aux
      });

      if(res.status === 200) {
        const auxApiMails = res.data.data;
        let objCampaignTosendApi = {
          account: authContext?.user?.account_id || '',
          campaign_id: auxApiMails.id,
          templates: auxApiMails.templates,
          leads_ids: auxApiMails.listleadsIds,
          msg_info: auxApiMails.msgInfo,
        }

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(objCampaignTosendApi)
        };

        const requestOptionsGet = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        };
        
        try {
          const response = await fetch('/mails-api/send_campaign/', requestOptions);
          const result = await readCampaignResponse(response);
          setCampaignResult(result);
          setCampaignState(true);
        } catch (err) {
          setCampaignError(err.campaign || {
            message: 'La conexión se interrumpió y no se pudo confirmar el envío. Revisa el estado de la campaña antes de volver a enviar.',
            deliveryUnknown: true,
          });
          setCampaignState(false);
          return;
        }
        // Delivery polling cannot undo a confirmed Mailgun acceptance.
        setTimeout(async () => {
          try {
            const response = await fetch(`/mails-api/mail_status/?campaign_id=${encodeURIComponent(auxApiMails.id)}`, requestOptionsGet);
            await readCampaignResponse(response);
          } catch (err) {
            setStatusWarning('Mailgun aceptó el envío, pero no pudimos actualizar el estado de entrega. Consulta la campaña más tarde; no vuelvas a enviarla.');
          }
        }, 7000);
      }
      else throw new Error('Unexpected campaign creation response');
    }
    catch(err){
      setCampaignError({ message: 'No se pudo crear la campaña. Revisa los datos o vuelve a iniciar sesión.' });
      setCampaignState(false);
    }
  }

  const createCampaign = () => {
    window.location.href = window.location.origin + '/campaign';
  };

  return (
    <Fragment>
      {campaignState &&
        <div>
          <div style={{ marginTop: '-40px' }}>
            <ProgressSteps items={[
                { name: 'Crear', url: '/creation', completed: true },
                { name: 'Audiencia', url: '/camp-audience', completed: true },
                { name: 'Plantillas', url: '/theme', completed: true },
                { name: 'Resumen', url: '/summary', completed: true },
                { name: 'Listo', url: '/finish', completed: true },
            ]} marginRight='-15px' shadow locked/>
          </div>

          <div className={ Style['title-ok'] }>
              ¡LISTO!
          </div>
          <div className={ Style['title-sub'] }>
              {campaignResult?.total
                ? `Mailgun aceptó ${campaignResult.accepted} de ${campaignResult.total} mensajes.`
                : 'Mailgun aceptó el envío de tu campaña.'}
          </div>
          <p className={ Style['result-detail'] }>La entrega final puede tardar. Puedes consultar su estado en Campañas.</p>
          {statusWarning && <p role='status' className={ Style['result-detail'] }>{statusWarning}</p>}
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <img width={350} height={350} src={ Astronauta } alt='Logo' />
          </div>
        </div>
      }
      {campaignState === null && 
        <Loader/>
      }
      {campaignState === false &&
        <div>
          <div style={{ marginTop: '-40px' }}>
            <ProgressSteps items={[
                { name: 'Crear', url: '/creation', completed: true },
                { name: 'Audiencia', url: '/camp-audience', completed: true },
                { name: 'Plantillas', url: '/theme', completed: true },
                { name: 'Resumen', url: '/summary', completed: true },
                { name: 'Listo', url: '/finish', completed: true },
            ]} marginRight='-15px' shadow locked/>
          </div>

          <div className={ Style['title-ok'] }>
              {campaignError?.accepted > 0 ? 'Envío incompleto' : campaignError?.deliveryUnknown ? 'Envío sin confirmar' : 'No se pudo enviar tu campaña'}
          </div>
          <div role='alert' className={ Style['result-detail'] }>
              <p>{campaignError?.message || 'No se pudo completar la campaña.'}</p>
              {campaignError?.providerMessage && <p>Respuesta de Mailgun: {campaignError.providerMessage}</p>}
              {campaignError?.total > 0 && <p>Mailgun aceptó {campaignError.accepted} de {campaignError.total} mensajes.</p>}
              {(campaignError?.accepted > 0 || campaignError?.deliveryUnknown) &&
                <p>No vuelvas a enviar la campaña completa: podrías duplicar mensajes.</p>}
          </div>
          <div className={ Style.buttonCreateCampaign }>
            <Button
              color='brand'
              text='Ver campañas'
              rounded
              small
              action={ createCampaign }
            />
          </div>
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <img width={350} height={350} src={ Fail } alt='LogoFail' />
          </div>
        </div>
      }
    </Fragment>
  )
}
